import { memo } from 'react'
import { TextField } from '@mui/material'

const CustomInput = memo(({ placeholder, value, onChange, multiline = false, rows = 1, name, required, disabled }) => (
	<TextField
		fullWidth
		multiline={multiline}
		rows={rows}
		placeholder={placeholder}
		value={value || ''}
		onChange={onChange}
		name={name}
		required={required}
		color='info'
		label={placeholder}
		InputProps={{ sx: { borderRadius: '16px', backgroundColor: disabled ? '#efefef!important' : 'white' } }}
		disabled={disabled}
	/>
))

CustomInput.displayName = 'CustomInput'

export default CustomInput

// {
// 	p: 0,
// 	display: 'flex',
// 	alignItems: 'center',
// 	border: '1px solid #ccc',
// 	borderRadius: '30px',
// 	overflow: 'hidden',
// 	bgcolor: 'white',
// }
